import { Haptics, ImpactStyle, NotificationType } from "@capacitor/haptics";
import { Capacitor } from "@capacitor/core";

/**
 * Haptics are the cheapest "this is an app, not a page" signal there is, and the easiest
 * to overdo. The house rule: a tap on a primary action, and the outcome of something the
 * user cannot undo. Never on scroll, never on every list row.
 *
 * Every call is fire-and-forget and swallows its error: a phone in low-power mode, a
 * simulator, or a browser must never turn "no vibration" into a rejected promise inside a
 * click handler.
 */
const supported = Capacitor.isNativePlatform();

export const haptics = {
  tap() {
    if (supported) void Haptics.impact({ style: ImpactStyle.Light }).catch(() => {});
  },
  press() {
    if (supported) void Haptics.impact({ style: ImpactStyle.Medium }).catch(() => {});
  },
  success() {
    if (supported) void Haptics.notification({ type: NotificationType.Success }).catch(() => {});
  },
  warning() {
    if (supported) void Haptics.notification({ type: NotificationType.Warning }).catch(() => {});
  },
  error() {
    if (supported) void Haptics.notification({ type: NotificationType.Error }).catch(() => {});
  },
  selection() {
    if (supported) void Haptics.selectionChanged().catch(() => {});
  },
};
